<template>
    <div class="content">
        <h2 class="content_title">Today's Goal</h2>
        <div class="plan_wrap">
            <div class="planhead clearfix">
                <div class="plan_title float_left clearfix">
                    <img :src="'../assets/images/goal_txt.png'" alt="Today's Goal" class="pcgoalimg float_left">
                    <p class="float_left">이번 시간의 <strong class="bold">학습 내용</strong>과<span><strong class="bold">학습 목표</strong>를 확인해보세요.</span></p>
                </div>
            </div>
            <div class="plan_cont_wrap clearfix">
                <div class="plan_cont float_left">
                    <h3 class="title"><span class="plandot1"></span>학습 내용</h3>
                    <ul>
                        <li v-for="body1 in contents.currentSlide.body1" v-html="body1"></li>
                    </ul>
                </div>
                <div class="plan_cont float_right">
                    <h3 class="title"><span class="plandot2"></span>학습 목표</h3>
                    <ul>
                        <li v-for="body2 in contents.currentSlide.body2" v-html="body2"></li>
                    </ul>
                </div>
            </div>
        </div>
        <audio v-if="contents.currentSlide.bgm != undefined" ref="currentAudio">
            <source :src="'../assets/media/' + contents.currentSlide.bgm" type="audio/mpeg">
        </audio>
    </div>
</template>
<script>
export default {
    props: ['contents'],
    data(){
        return{
            list : []
        }
    },
    methods:{
        getList(){
        }
    },
    mounted(){
        setTimeout(()=>{
            this.$refs.currentAudio.play()
        }, 1000);
        setTimeout(()=>{
            if(this.contents.currentSlide.autoNext == 'Y'){
                this.$emit('nextPage',1);       
            }else if(this.contents.currentSlide.autoNext == 'P'){
                swal({
                    title: "알림",
                    text: "다음 페이지로 넘어가시겠습니까?",
                    icon: "info",
                    buttons: true
                }).then((willUpdate) => {
                    if (willUpdate) {
                        this.$emit('nextPage',1);       
                    }
                });
            }
        }, this.contents.currentSlide.duration);
    }
}
</script>